export default __webpack_public_path__ + "static/media/unilabs.4227bd24.png";